export default __webpack_public_path__ + "static/media/gavel.97f5faeb.svg";